var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg001(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9106 7.20837H9.33325V6.50004C9.33325 3.37043 11.8703 0.833374 14.9999 0.833374H23.4999C26.6295 0.833374 29.1666 3.37043 29.1666 6.50004V15C29.1666 18.1297 26.6295 20.6667 23.4999 20.6667H22.7916V14.0893C22.7916 10.2891 19.7109 7.20837 15.9106 7.20837ZM6.49992 29.1667H14.9999C18.1295 29.1667 20.6666 26.6297 20.6666 23.5V15C20.6666 11.8704 18.1295 9.33337 14.9999 9.33337H6.49992C3.37031 9.33337 0.833252 11.8704 0.833252 15V23.5C0.833252 26.6297 3.3703 29.1667 6.49992 29.1667ZM15.6996 15.6171C16.1412 16.0035 16.1859 16.6748 15.7995 17.1164L11.7338 21.7629C10.8602 22.7614 9.35533 22.8951 8.31934 22.0663L5.83618 20.0797C5.37796 19.7132 5.30367 19.0445 5.67024 18.5863C6.03681 18.1281 6.70544 18.0538 7.16365 18.4204L9.64682 20.4069C9.79481 20.5253 10.0098 20.5062 10.1346 20.3636L14.2003 15.7171C14.5867 15.2754 15.258 15.2307 15.6996 15.6171Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg001);
export default __webpack_public_path__ + "static/media/001.496e45c1d7d48d6d75c83189a857c095.svg";
export { ForwardRef as ReactComponent };